import React from "react";
import Layout from "../Layout";
import { Box, Grid } from "@mui/material";
import TaskWork from "../../../shared/Layout/TaskWork";
import NowWorks from "../../../widgets/supervisor/dashboard/NowWorks";
import NowWeekend from "../../../widgets/supervisor/dashboard/NowWeekend";
import { operators } from "../../../data/supervisor/dashboard/NowWeekend";
import { operatorsWork } from "../../../data/supervisor/dashboard/NowWorks";
import { operatorsRating } from "../../../data/supervisor/dashboard/RatingOperators";
import RatingTableContainer from "../../../shared/OperatorsList/RatingTable";

function DashboardSupervisor(props) {
  return (
    <Layout>
      <Grid sx={{ mb: 2 }} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 7 }}>
        <TaskWork title="Завдання для операторів" activeCount={5} />
      </Grid>
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            xl: "row",
          },
          gap: 2,
          alignItems: "stretch",
          mb: 2,
        }}
      >
        <Box
          sx={{
            flex: { xl: "0 0 70%", xs: "1 1 100%" },
            display: "flex",
            flexDirection: "column",
          }}
        >
          <NowWorks operatorsWork={operatorsWork} />
        </Box>

        <Box
          sx={{
            flex: { xl: "0 0 29%", xs: "1 1 100%" },
            display: "flex",
            flexDirection: "column",
          }}
        >
          <NowWeekend operators={operators} />
        </Box>
      </Box>
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 7 }}>
        <RatingTableContainer
          operatorsRating={operatorsRating}
          title="Рейтинг операторів (Supervisor)"
        />
      </Grid>
    </Layout>
  );
}

export default DashboardSupervisor;
